import { adminHttpClient } from '../../commons/adminHttpClient'
import PagedList from '../../commons/PagedList'
import EmailStatus from '../../../domain/mailHistory/emailStatus'

type CompanyUserDetails = {
  firstName: string
  lastName: string
}

export type SearchEmailItemResponse = {
  id: string
  companyUser: CompanyUserDetails
  sendDate?: string
  initiatedOn?: string
  subject: string
  receiverEmailAddress: string
  status: EmailStatus
  statusDetails: string
  canResend: boolean
}

export type EmailContentResponse = {
  id: string
  sendDate?: string
  subject: string
  from: string
  to: string
  htmlContent: string
}

export type SearchEmailFilter = {
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
  status?: EmailStatus
  q?: string
}

export const searchEmails = (filter: SearchEmailFilter): Promise<PagedList<SearchEmailItemResponse>> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 25,
    orderColumn: 'createdAt',
    orderDescending: false,
  }

  return adminHttpClient.get('/csi/Emails/Search', filter)
}

export const getEmail = (id: string): Promise<EmailContentResponse> => {
  return adminHttpClient.get('/csi/emails/' + id)
}
